import { assert_string_object_id, assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestImageAiDescriptionCreateOrTranslate extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_IMAGE_AI_DESCRIPTION_CREATE_OR_TRANSLATE;

  language!: string;
  image_id!: string;
  workspace_id!: string;

  /*
   * METHODS
   */
  assert_standard_fields(): void {
    assert_type_enum(this.language, ENUM__language_type);
    assert_string_object_id(this.image_id);
    assert_string_object_id(this.workspace_id);
  }
}
